export default __webpack_public_path__ + "static/media/arrow-right-carousel.9ad598a0.svg";